import React from "react";
import "./index.scss";
import img from "../../../assets/images/mission.png"; // Assurez-vous que le chemin est correct
export const Mission = () => {
  return (
    <div className="mission">
      {" "}
      <div className="row ms-0 justify-content-center  gx-0 w-100 align-items-center mb-5">
        <div className="col-12 col-md-6 mx-auto ">
          <div className="mission-title">Notre mission</div>
          <div className="mission-text mt-3">
            Améliorer le confort thermique, valoriser les biens immobiliers et
            permettre à nos clients de profiter des aides financières
            disponibles pour la transition énergétique.
          </div>
        </div>
        <div className="col-12 col-md-6 mx-auto d-flex justify-content-center align-items-center">
          <img src={img} alt="mission" className="img-fluid mt-5 mt-md-0" />
        </div>
      </div>
    </div>
  );
};
